import { __assign, __rest } from "tslib";
import React from 'react';
import VeltCommentDialogThreadCardSeenDropdownContentTitle from './VeltCommentDialogThreadCardSeenDropdownContentTitle/VeltCommentDialogThreadCardSeenDropdownContentTitle';
import VeltCommentDialogThreadCardSeenDropdownContentItems from './VeltCommentDialogThreadCardSeenDropdownContentItems/VeltCommentDialogThreadCardSeenDropdownContentItems';
import { transformWireframeProps } from '../../../../../utils/propUtils';
var VeltCommentDialogThreadCardSeenDropdownContent = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-thread-card-seen-dropdown-content-wireframe", __assign({}, transformedProps), children));
};
VeltCommentDialogThreadCardSeenDropdownContent.Title = VeltCommentDialogThreadCardSeenDropdownContentTitle;
VeltCommentDialogThreadCardSeenDropdownContent.Items = VeltCommentDialogThreadCardSeenDropdownContentItems;
export default VeltCommentDialogThreadCardSeenDropdownContent;
